module.exports = __webpack_public_path__ + "img/login_cover.de4376e6.png";